export default __webpack_public_path__ + "static/media/iplSvg.7087e385.jpg";